import { render, staticRenderFns } from "./ModProfileForm.vue?vue&type=template&id=138c11fa&"
import script from "./ModProfileForm.vue?vue&type=script&lang=js&"
export * from "./ModProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports